import React from "react";

const IndividualAuthHeader = ({ title, subtitle, onBack, backText = "Back" }) => {
  return (
    <div className="w-full flex flex-col mb-4">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-bold text-gray-800 hover:text-black mb-2 transition-colors w-fit focus:outline-none cursor-pointer"
        >
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
          </svg>
          <span>{backText}</span>
        </button>
      )}

      {title && (
        <h3 className="text-xl sm:text-2xl font-extrabold text-[#111827] tracking-tight leading-tight mb-0.5">
          {title}
        </h3>
      )}

      {subtitle && (
        <p className="text-xs text-gray-500 font-medium leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default IndividualAuthHeader;
